module.exports = __webpack_public_path__ + "static/media/24596aa1bcbab716ccb4e6bc7404fe2e4592865e.4bf74525.png";